import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export type PopupType = 'success' | 'warning' | 'error' | 'confirmation';

export interface PopupState {
  visible: boolean;
  type: PopupType;
  title: string;
  content: string;
  buttonText?: string;
}

@Injectable({ providedIn: 'root' })
export class StatusPopupService {

  private popupState = new BehaviorSubject<PopupState>({
    visible: false,
    type: 'success',
    title: '',
    content: '',
    buttonText: 'OK'
  });

  popup$ = this.popupState.asObservable();

  // 🔹 NEW: close event
  private closeSubject = new Subject<void>();
  close$ = this.closeSubject.asObservable();

  success(details: {title: string, content: string, buttonText?: string}) {
    this.open('success', details.title, details.content, details.buttonText);
  }

  warning(details: {title: string, content: string, buttonText?: string}) {
    this.open('warning', details.title, details.content, details.buttonText);
  }

  error(details: {title: string, content: string, buttonText?: string}) {
    this.open('error', details.title, details.content, details.buttonText);
  }

  confirmation(details: {title: string, content: string, buttonText?: string}) {
    this.open('confirmation', details.title, details.content, details.buttonText);
  }

  close() {
      this.popupState.next({
        ...this.popupState.value,
        visible: false
      });
      this.closeSubject.next();
  }

  closeOnly() {
    this.popupState.next({
      ...this.popupState.value,
      visible: false
    });
  }

  private open(type: PopupType, title: string, content: string, buttonText?: string) {
    this.popupState.next({
      visible: true,
      type,
      title,
      content,
      buttonText: buttonText ?? 'OK'
    });
  }
}
